import { useParams } from '@fs/zion-router'
import { type PID, type RelationshipId } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const CHANGELOG_PATHS = [
  `/changelog/:pid(${pidRegexStr as PID})/:relationshipType(parent-child|couple|association)/:relationshipId`,
  `/changelog/:pid(${pidRegexStr as PID})/:filterType?`,
] as const

type ChangelogParams = PathParamMap<typeof CHANGELOG_PATHS> & {
  relationshipId?: RelationshipId
}

export const useChangelogParams = (): ChangelogParams => useParams<ChangelogParams>()
